// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IRecordValidationErrorDto } from './IRecordValidationErrorDto';
import {
    IRecordValidationErrorDtoFromJSON,
    IRecordValidationErrorDtoFromJSONTyped,
    IRecordValidationErrorDtoToJSON,
    IRecordValidationErrorDtoToJSONTyped,
} from './IRecordValidationErrorDto';

/**
 * 
 * @export
 * @interface IContributionSegmentResponseDto
 */
export interface IContributionSegmentResponseDto {
    /**
     * 
     * @type {number}
     * @memberof IContributionSegmentResponseDto
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof IContributionSegmentResponseDto
     */
    contribution_request_id?: number;
    /**
     * 
     * @type {string}
     * @memberof IContributionSegmentResponseDto
     */
    contribution_id?: string;
    /**
     * 
     * @type {Date}
     * @memberof IContributionSegmentResponseDto
     */
    contribution_date?: Date;
    /**
     * 
     * @type {string}
     * @memberof IContributionSegmentResponseDto
     */
    tax_type?: IContributionSegmentResponseDtoTaxTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof IContributionSegmentResponseDto
     */
    tax_year?: string;
    /**
     * 
     * @type {string}
     * @memberof IContributionSegmentResponseDto
     */
    contribution_segment_type?: IContributionSegmentResponseDtoContributionSegmentTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof IContributionSegmentResponseDto
     */
    memo?: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof IContributionSegmentResponseDto
     */
    segment_subsidiary_ids?: Array<number>;
    /**
     * 
     * @type {Array<string>}
     * @memberof IContributionSegmentResponseDto
     */
    segment_plan_codes?: Array<string>;
    /**
     * 
     * @type {Array<number>}
     * @memberof IContributionSegmentResponseDto
     */
    segment_employee_ids?: Array<number>;
    /**
     * 
     * @type {Array<string>}
     * @memberof IContributionSegmentResponseDto
     */
    segment_payroll_group_codes?: Array<string>;
    /**
     * 
     * @type {Array<IRecordValidationErrorDto>}
     * @memberof IContributionSegmentResponseDto
     */
    errors?: Array<IRecordValidationErrorDto>;
}

/**
* @export
* @enum {string}
*/
export enum IContributionSegmentResponseDtoTaxTypeEnum {
    PRE_TAX = 'PRE_TAX',
    POST_TAX = 'POST_TAX'
}
/**
* @export
* @enum {string}
*/
export enum IContributionSegmentResponseDtoContributionSegmentTypeEnum {
    SINGLE = 'SINGLE',
    ALL_EMPLOYEES = 'ALL_EMPLOYEES',
    PLANS = 'PLANS',
    SUBSIDIARY = 'SUBSIDIARY',
    PAYROLL_GROUP = 'PAYROLL_GROUP'
}


/**
 * Check if a given object implements the IContributionSegmentResponseDto interface.
 */
export function instanceOfIContributionSegmentResponseDto(value: object): value is IContributionSegmentResponseDto {
    return true;
}

export function IContributionSegmentResponseDtoFromJSON(json: any): IContributionSegmentResponseDto {
    return IContributionSegmentResponseDtoFromJSONTyped(json, false);
}

export function IContributionSegmentResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IContributionSegmentResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'contribution_request_id': json['contribution_request_id'] == null ? undefined : json['contribution_request_id'],
        'contribution_id': json['contribution_id'] == null ? undefined : json['contribution_id'],
        'contribution_date': json['contribution_date'] == null ? undefined : (new Date(json['contribution_date'])),
        'tax_type': json['tax_type'] == null ? undefined : json['tax_type'],
        'tax_year': json['tax_year'] == null ? undefined : json['tax_year'],
        'contribution_segment_type': json['contribution_segment_type'] == null ? undefined : json['contribution_segment_type'],
        'memo': json['memo'] == null ? undefined : json['memo'],
        'segment_subsidiary_ids': json['segment_subsidiary_ids'] == null ? undefined : json['segment_subsidiary_ids'],
        'segment_plan_codes': json['segment_plan_codes'] == null ? undefined : json['segment_plan_codes'],
        'segment_employee_ids': json['segment_employee_ids'] == null ? undefined : json['segment_employee_ids'],
        'segment_payroll_group_codes': json['segment_payroll_group_codes'] == null ? undefined : json['segment_payroll_group_codes'],
        'errors': json['errors'] == null ? undefined : ((json['errors'] as Array<any>).map(IRecordValidationErrorDtoFromJSON)),
    };
}

export function IContributionSegmentResponseDtoToJSON(json: any): IContributionSegmentResponseDto {
    return IContributionSegmentResponseDtoToJSONTyped(json, false);
}

export function IContributionSegmentResponseDtoToJSONTyped(value?: IContributionSegmentResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'contribution_request_id': value['contribution_request_id'],
        'contribution_id': value['contribution_id'],
        'contribution_date': value['contribution_date'] == null ? undefined : ((value['contribution_date']).toISOString().substring(0,10)),
        'tax_type': value['tax_type'],
        'tax_year': value['tax_year'],
        'contribution_segment_type': value['contribution_segment_type'],
        'memo': value['memo'],
        'segment_subsidiary_ids': value['segment_subsidiary_ids'],
        'segment_plan_codes': value['segment_plan_codes'],
        'segment_employee_ids': value['segment_employee_ids'],
        'segment_payroll_group_codes': value['segment_payroll_group_codes'],
        'errors': value['errors'] == null ? undefined : ((value['errors'] as Array<any>).map(IRecordValidationErrorDtoToJSON)),
    };
}

